import { Route } from "react-router-dom";
import { AuthContext, IAuth, Rotina } from "../../context/Auth";
import { useContext } from "react";
import DashboardPg from "./DashboardPg";
import RelatorioPg from "./RelatorioPg";
import AssiciarMembroPg from "./AssociarMembroPg";
import Visitante from "../Acolher/Visitante";
import Info from "./Lista";
import ConexoesPg from "./ConexoesPg";
import EventosPg from "./Eventos";
import Celula from "../Cadastros/Celula";
import EditCelula from "../Cadastros/Celula/Edit";
import AddCelula from "../Cadastros/Celula/Add";
import ListaMembrosPg from "./Lista/children/lista/listLideres";
import AddLideres from "./Lista/children/lista/addLideres";
import AddEvento from "./Eventos/children/form";
import EditEvento from "./Eventos/children/edit/edit";
import EditVisitante from "../Acolher/Visitante/children/edit";


export function Routes() {

  const { usuarioRotinas } = useContext<IAuth>(AuthContext);

  const rotina = (usuarioRotinas||[])?.map((rotina: Rotina) => rotina?.nomerotina)

  return (
    <>
      {
        rotina?.some((rotina: string) => rotina == "Dashboard Pg") ?
          <Route path='/dash/pequenogrupo/dashpg' element={< DashboardPg />} />
          : false
      }

      {
        rotina?.some((rotina: string) => rotina == "Dashboard Pg") ?
          <Route path='/dash/pequenogrupo/membrossempg' element={< RelatorioPg />} />
          : false
      }

      {
        rotina?.some((rotina: string) => rotina == "Lista de Membros") ?
          <Route path='/dash/pequenogrupo/membros' element={< AssiciarMembroPg />}/>
          : false
      }

      {
        rotina?.some((rotina: string) => rotina == "Visitante") ?
          <>
            <Route path={'/dash/acolher/visitantes'} element={<Visitante />} >

              <Route path={'edit/:id'} element={<EditVisitante />} />
            </Route>
          </>
          : false
      }

      {
        rotina?.some((rotina: string) => rotina == "Lista de Pg") ?
          <Route path="/dash/pequenogrupo/info" element={<Info />}>
            <Route path="lista/:id" element={<ListaMembrosPg />} />
            <Route path="lista/:id/add/coordenadores" element={<AddLideres />} />
          </Route>
          : false
      }

      {
        rotina?.some((rotina: string) => rotina == "Conexão Pg") ?
          <Route path="/dash/pequenogrupo/conexoes" element={<ConexoesPg />} />
          : false
      }
      {
        rotina?.some((rotina: string) => rotina == "Evento Pg") ?
          <Route path="/dash/pequenogrupo/eventos" element={<EventosPg />} >
            <Route path="add" element={<AddEvento />} />
            <Route path="edit/:id" element={<EditEvento />} />
          </Route>
          : false
      }


      {
        rotina?.some((rotina: string) => rotina == "Cadastro Pg") ?
          <Route path="dash/pequenogrupo/celula" element={<Celula />} >
            <Route path="editar/:id" element={<EditCelula />} />
            <Route path="add" element={<AddCelula />} />
          </Route>
          : false
      }

    </>
  )
}
